import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function Adornment({ children, direction, className, position = direction === 'start' ? 'left-0' : 'right-0', }) {
    if (!children)
        return null;
    return (_jsx("div", { className: clsx('pointer-events-none absolute top-0 z-10 flex h-full min-w-42 items-center justify-center text-muted', position, className), children: children }));
}
